import { View } from "ui/atoms/view";
import { Pressable, Text } from "react-native";
import { Icon, MessageCircleIcon } from "ui/gluestack/icon";
import { useState } from "react";
import { CloseIcon } from "ui/gluestack/icon/index.web";

export function FeedbackForm() {
  const [showForm, setShowForm] = useState(false);
  return (
    <View className="fixed bottom-0 right-0">
      <script
        async
        src="https://app-cdn.clickup.com/assets/js/forms-embed/v1.js"
      ></script>
      <Pressable
        className="transform -mb-8 -mr-8 lg:mb-0 lg:mr-0 hover:mb-0 hover:mr-0 duration-300"
        onPress={() => setShowForm(!showForm)}
      >
        <View className="rounded-full bg-primary-500 p-2 drop-shadow-md mr-4 mb-4">
          <Icon as={MessageCircleIcon} className="w-8 h-8 stroke-white" />
        </View>
      </Pressable>

      {showForm ? (
        <Pressable
          className="absolute bottom-0 right-0 w-screen h-screen items-end justify-end p-4 bg-black/20"
          onPress={() => setShowForm(false)}
        >
          <View className="bg-white rounded-xl overflow-hidden drop-shadow-md max-w-full max-h-full w-[600px] h-[1200px]">
            <View className="w-full border-b border-gray-100 flex-row justify-between py-2 px-4 drop-shadow items-center">
              <Text className="font-semibold text-lg">
                Give us your feedback!
              </Text>
              <Pressable onPress={() => setShowForm(false)}>
                <Icon as={CloseIcon} className="h-4 w-4" />
              </Pressable>
            </View>
            <iframe
              className="clickup-embed clickup-dynamic-height"
              src="https://forms.clickup.com/2510809/f/2ckyt-12035/0YBYZFLUWUV20OBPHA"
              onWheel={undefined}
              width="100%"
              height="100%"
            ></iframe>
          </View>
        </Pressable>
      ) : null}
    </View>
  );
}
